import React, {Fragment} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import {
  defaultTableHeaderStyles,
  defaultPaginationOptions,
} from "./BaseTableComponents";

import '../Tables/Table.scss'
import IconTooltip from "ui/Tooltip/IconTooltip";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle} from "root/Tables/BaseTableComponents";
import {Globals} from "root/DataFunctions/BaseDataFns";
import { schoolRouteUrl} from "root/Tables/TableMyPEPs";
import {Link} from "react-router-dom";

const TableSchools = (props) =>
{
  const onClickEdit = ( school_id ) =>
  {
    props.clickHandler (school_id, 'edit', props.onDialogClosed );
  }

  const linkFormatter = (cell, row) => {

    let returnURL = btoa(Globals.BaseURL + '/vschool/schools');

    const viewChildURL = schoolRouteUrl(row.school_id, null, returnURL ) ;

    return (
        <Fragment>
          <Link to={viewChildURL} style={{marginRight: '10px'}}><IconTooltip href={+row.school_id} placement='top' text="View School" icon="glyphicon-eye-open" color="var(--s360-icon-green)"/></Link>
          <IconTooltip onClick={() => onClickEdit (row.school_id)} placement='top' text="Edit Details" style={{marginRight: '10px'}} icon="glyphicon-pencil" color="var(--s360-icon-blue)"/>
        </Fragment>
    );
  }

  const schoolNameFormatter = (cell, row, rowIndex, formatExtraData) => {

    let returnURL = btoa(Globals.BaseURL + '/vschool/schools');

    const viewChildURL = schoolRouteUrl(row.school_id, null, returnURL ) ;

    return (
        <Fragment>
          <Link to={viewChildURL}>{row.school_name}</Link>
        </Fragment>
    );
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    school_id: {borderRadius: defaultTopLeftCellStyle, width: "12vw", minWidth: '8rem'},
    view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw", minWidth: '8rem'}
  });


  const getColumns = () => {
    const columns = [
      {
        dataField: "school_id",
        text: "School Id",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "school_name",
        text: "School Name",
        sort: true,
        formatter: schoolNameFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "school_type_desc",
        text: "Type",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "view",
        text: "",
        align: 'right',
        formatter: linkFormatter,
        headerStyle: headerStyle
      }
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, []);

  const tableContent = () =>
  {
    return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>

  }

  return props.loading === true ? <SpinnerDiv/> : tableContent();
};

export default TableSchools;
